
import React, { useCallback, useState,useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import HTMLReactParser from 'html-react-parser';
import '../css/Contact.css';
import axios from 'axios';
import CallusM from "../components/Img/Callusmobile.png";
import CallusD from "../components/Img/Callusdesktop.png";


export default function Contact() {
  // stores current formRef
  const [node, setNode] = useState(null);
  // tracks changes to formRef and stores current with setNode
  const formRef = useCallback((node) => {
    setNode(node);
  }, []);

  const queryParams = new URLSearchParams(window.location.search);
  const key = queryParams.get('key');
  const [heading, setHeading] = useState('');
  const [mloPhoneNumber, setMloPhoneNumber] = useState();

  function trim(theStr) {
    return theStr.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
  }

  function getNumbers(inVal, isDouble, removeCharsFromPrefix) {
    var retVal = '';
    var okChars = '0123456789';
    var tmpVal = trim(inVal);
    var curChar = '';
    var isDotFound = false;

    if (tmpVal !== '') {
      for (var i = 0; i < tmpVal.length; i++) {
        curChar = tmpVal.charAt(i);

        if (okChars.indexOf(curChar) !== -1) {
          if (!isDotFound && curChar === '.' && isDouble) {
            isDotFound = true;
            retVal = retVal + '.';
          }

          if (retVal === '' && removeCharsFromPrefix.indexOf(curChar) !== -1) {
            //Do nothing
          } else {
            retVal += curChar;
          }
        }
      }
    }

    return retVal;
  }

  const handleMLOPhoneNumber = (phoneNum) => {
    //Save Phone number in local storage for Apply
    var tmpVal = trim(getNumbers(phoneNum, false, '01'));
    if (tmpVal === "") {
      return '(844) SUN-WEST / (844) 786-9378';
    }
    var FirstThreeDigit = tmpVal.substring(0, 3);
    var FirstSixDigit = tmpVal.substring(0, 6);

    /* Below Pattern will check numbers between below ranges
        456, 555, 900,
        100, 101, ..., 199
        211, 311, ..., 911  ***811 removed
        370, 371, ..., 379
        960, 961, ..., 969
        800, 801, ..., 855  ***removed
        866, 877, 888, 800855
        */
    var patt =
      /^(1[0-9][0-9])|([2-7]11)|(911)|(37[0-9])|(96[0-9])|(456)|(555)|(866)|(877)|(888)|(900)$/;
    var patt2 = /^800855$/;
    if (patt.test(FirstThreeDigit)) {
      return '(844) SUN-WEST / (844) 786-9378';
    } else if (patt2.test(FirstSixDigit)) {
      return '(844) SUN-WEST / (844) 786-9378';
    }

    var curChar = '';
    var areaCode = '';
    var firstThree = '';
    var lastFour = '';
    var extension = '';

    if (tmpVal !== '') {
      for (var i = 0; i < tmpVal.length; i++) {
        curChar = tmpVal.charAt(i);

        if (i < 3) areaCode += curChar;
        if (i < 6 && i > 2) firstThree += curChar;
        if (i < 10 && i > 5) lastFour += curChar;
        if (i > 9) extension += curChar;
      }
    }

    var retVal = '';

    /* Do not put the parentesis if we only have the first three digits of the phone number.
    Once we are past that then start formatting the phone number. This was the main issue
    why the phone number couldn't be blanked out in it's entirety.*/
    if (areaCode !== '' && firstThree === '') retVal += areaCode;
    else if (areaCode !== '' && firstThree !== '') retVal += '(' + areaCode + ')';

    if (firstThree !== '') retVal += ' ' + firstThree;

    if (lastFour !== '') retVal += '-' + lastFour;

    if (extension !== '') retVal += ' x' + extension;

    return retVal;
  };

  useEffect(() => {
    if (key) {
      axios
        .post(process.env.REACT_APP_SUNSOFT_API_GET_SESSION_KEY, {"key":key}, {
          headers: { 'Content-Type': 'application/json' },
        })
        .then((response) => {
          let userData = response.data.parameters;

          if (userData.heading) {
            const headingContent = '<h2 className="pt-sm-2 pt-md-4 text-center">' +
              userData.heading + '</h2>'
            const htmlHeadingContent = HTMLReactParser(headingContent);
            setHeading(htmlHeadingContent);
          }

          if (userData.mloPhoneNumber) {
            setMloPhoneNumber(handleMLOPhoneNumber(userData.mloPhoneNumber));
          }
          return response;
        });
    }

    if (!mloPhoneNumber) {
      setMloPhoneNumber('(844) SUN-WEST / (844) 786-9378');
    }

    if (!heading) {
      const defaultHeadingContent = '<div>' +
        '<h1 className="pt-sm-2 pt-md-4 text-center">Welcome!</h1>' +
        '<h2 className="pb-sm-2 pb-md-3 text-center">' +
        'We&#39;re here to assist you with any questions' +
        '<br /> you may have about your mortgage.' +
        '</h2>' +
        '</div>';

      const defaultHTMLHeadingContent = HTMLReactParser(defaultHeadingContent);
      setHeading(defaultHTMLHeadingContent);
    }
  }, [key]);

  return (
    /* keeps original css for this form */
    <div id="contactUsForm">
    <Container fluid id="form-wrapper">
    <a href="tel:+18447869378" >
          <img
          src={CallusD}
          alt="Calluslogo"
          className="CallusD"
          title="tel:+18447869378"
          />
          </a>
      <Row className="justify-content-center">
        <Col md={12} lg={8} xl={6} className="text-center">
          {heading}
          <a href="tel:+18447869378" >
          <img
          src={CallusM}
          alt="Calluslogo"
          className="CallusM"
          title="tel:+18447869378"
          />
          </a>
          <h3 className="text-center">Let&#39;s start with something simple.</h3>
        </Col>
        <Col className="" id="contactLeadform" md={11} lg={10} xl={10}>
            <BorrowerLeadGenerationTool 
            ref={formRef}
            showPropertyStateField={false}
            leadSource="NET001" 
            mainBtnName="Tell Me More" 
            loanOfficerUid="CSTC"
            branch="058"
            domainNameConsent="swmc.com"
            language="en"/>
        </Col>
      </Row>
    </Container>
    </div>
  );
}
